import { createRoutes } from 'shared/hocs'

import Layout from './shared/layout'
import { Events } from './events'
import { Members } from './members'
import { Triggers } from './triggers'
import { Beneficiaries } from './beneficiaries'
import { Timemachine } from './timemachine'
import { Athletes } from './athletes'
import { Teams } from './teams'
import { Sponsors } from './sponsors'
import { Tournaments } from './tournaments'
import { Charts } from './charts'

const AdminRoutes = createRoutes(
  ({ match }) => [
    {
      redirect: {
        exact: true,
        from: match.path,
        to: `${match.path}/beneficiaries`,
      },
    },
    {
      path: `${match.path}/beneficiaries`,
      component: Beneficiaries,
    },
    {
      path: `${match.path}/events`,
      component: Events,
    },
    {
      path: `${match.path}/triggers`,
      component: Triggers,
    },
    {
      path: `${match.path}/members`,
      component: Members,
    },

    {
      path: `${match.path}/timemachine`,
      component: Timemachine,
    },
    {
      path: `${match.path}/athletes`,
      component: Athletes,
    },
    {
      path: `${match.path}/sponsors`,
      component: Sponsors,
    },
    {
      path: `${match.path}/teams`,
      component: Teams,
    },
    {
      path: `${match.path}/tournaments`,
      component: Tournaments,
    },
    {
      path: `${match.path}/charts`,
      component: Charts,
    },
  ],
  { switched: true, layout: Layout }
)

export default AdminRoutes
